'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _enabled, _inputStates, _ui;

var _polished = require('polished');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var branding = {
  favIconName: 'favicon-match',
  name: 'fantasticllama'
};

var space = {
  none: 0,
  xsmall: 4,
  small: 8,
  smedium: 12,
  medium: 16,
  large: 20,
  xlarge: 24,
  xxlarge: 32,
  xxxlarge: 40
};

var iconSizes = {
  xxsmall: 8,
  xsmall: 16,
  small: 24,
  medium: 32,
  large: 40,
  xlarge: 48,
  xxlarge: 56,
  xxxlarge: 64
};

var fontSizes = {
  xxxsmall: 11,
  xxsmall: 12,
  xsmall: 14,
  small: 16,
  medium: 18,
  large: 20,
  xlarge: 28,
  xxlarge: 32,
  xxxlarge: 36,
  xxxxlarge: 40
};

var fontVariants = function fontVariants() {
  return [{
    family: 'Core Sans',
    url: require('./static/fonts/CoreSans/CoreSans-45Regular.woff'),
    weight: '400',
    formats: 'woff'
  }, {
    family: 'Core Sans',
    url: require('./static/fonts/CoreSans/CoreSans-65Bold.woff'),
    weight: '700',
    formats: 'woff'
  }];
};

var typography = {
  h1: fontSizes.xxxxlarge,
  h2: fontSizes.xxxlarge,
  h3: fontSizes.xxlarge,
  h4: fontSizes.xlarge,
  h5: fontSizes.large,
  h6: fontSizes.small,
  largebody: fontSizes.small,
  smallbody: fontSizes.xsmall,
  metainfo: fontSizes.xxsmall,
  smallcaps: fontSizes.xxsmall,
  legal: fontSizes.xxxsmall
};

var lineHeights = {
  xsmall: '16px',
  small: '20px',
  medium: '24px',
  large: '32px',
  xlarge: '36px',
  xxlarge: '40px',
  xxxlarge: '44px'
};

var weights = {
  ultraLight: 100,
  light: 300,
  regular: 400,
  semibold: 500,
  bold: 700,
  extraBold: 800
};

var colors = {
  blue: '#1927f0',
  red: '#ff3e41',
  green: '#0fce11',
  magenta: '#f8278a',
  teal: '#44fffa',
  purple: '#ac18e5',
  salmon: '#fdd3d3',
  midnight: '#0a0e4d',
  wine: '#86154b',
  transparent: 'transparent',
  black: '#1a1b1c',
  white: '#FFFFFF',
  yellow: '#e3bc04'
};

var grays = {
  primary1: '#1A1B1C',
  primary2: '#2A2B2C',
  primary3: '#6A6A6B',
  primary4: '#949495',
  primary5: '#BFBFBF',
  primary6: '#E9E9E9',
  secondary1: '#FAFAFA',
  secondary2: '#BABBBB',
  secondary3: '#8C8D8D',
  secondary4: '#5F5F60'
};

var semanticColors = {
  primary1: colors.blue,
  primary2: colors.magenta,
  secondary1: colors.teal,
  secondary2: colors.purple,
  secondary3: colors.salmon,
  secondary4: colors.midnight,
  secondary5: colors.wine,
  secondary6: colors.yellow,
  functional1: colors.green,
  functional2: colors.red,

  ctaPrimary: colors.blue,
  ctaSecondary: colors.magenta,

  focusPrimary: (0, _polished.transparentize)(.95, colors.blue),

  textPrimary: grays.primary2,
  textSecondary: grays.primary3,
  textTertiary: grays.primary4,

  error: colors.magenta,
  success: colors.green,
  warning: grays.primary1,
  info: colors.blue,
  link: colors.blue,

  disabled: grays.primary5,
  stroke: grays.primary6,
  // focus: colors.teal
  transparent: colors.transparent,

  dark: colors.black,
  darkSubcopy: (0, _polished.transparentize)(.3, colors.black),
  darkTertiary: (0, _polished.transparentize)(.5, colors.black),
  darkGhost: (0, _polished.transparentize)(.7, colors.black),
  light: colors.white,
  lightSubcopy: (0, _polished.transparentize)(.3, colors.white),
  lightTertiary: (0, _polished.transparentize)(.5, colors.white),
  lightGhost: (0, _polished.transparentize)(.7, colors.white)
};

var zIndex = {
  drawer: 1000,
  modal: 900,
  tooltip: 400,
  overlay: 300,
  nav: 200,
  subnav: 100
};

var palette = (0, _extends4.default)({}, semanticColors);

var dropShadows = {
  z0: '0 24px 48px 0 transparent',
  // leaving room for anything less than 70% transparency
  z3: '0 24px 48px 0 ' + (0, _polished.transparentize)(.7, palette.secondary4),
  z4: '0 12px 24px 0 ' + (0, _polished.transparentize)(.7, palette.secondary4)
};

var font = {
  monospace: '\'Core Sans\', Helvetica, Arial, sans-serif',
  body: '\'Core Sans\', Helvetica, Arial, sans-serif'
};

var radii = {
  corner: 0,
  roundCorner1x: 8,
  roundCorner2x: 16,
  round: 1000
};

var focusStyles = {
  minimal: {
    disabled: {
      opacity: 0.3
    },
    enabled: (_enabled = {}, (0, _defineProperty3.default)(_enabled, ':focus', {
      outline: 'none',
      background: palette.focusPrimary,
      boxShadow: 'inset 0 0 0 1px ' + (0, _polished.transparentize)(.85, palette.primary1)
    }), (0, _defineProperty3.default)(_enabled, '::-moz-focus-inner', {
      border: 0
    }), (0, _defineProperty3.default)(_enabled, ':focus:not(:focus-visible)', {
      background: 'inherit'
    }), (0, _defineProperty3.default)(_enabled, ':focus-visible', {
      background: (0, _polished.transparentize)(.85, palette.primary1),
      boxShadow: 'inset 0 0 0 1px ' + (0, _polished.transparentize)(.8, palette.primary1)
    }), (0, _defineProperty3.default)(_enabled, ':hover', {
      background: (0, _polished.transparentize)(.95, palette.primary1)
    }), _enabled)
  }
};

var inputStates = (_inputStates = {
  outline: 0,
  color: palette.textPrimary,
  fontFamily: font.body,
  fontSize: fontSizes.small,
  ':hover': {
    background: palette.focusPrimary,
    borderColor: semanticColors.primary1,
    ':focus': {
      background: 'inherit'
    }
  }
}, (0, _defineProperty3.default)(_inputStates, '@media (hover: none)', {
  ':hover': {
    background: 'inherit'
  }
}), (0, _defineProperty3.default)(_inputStates, ':focus', {
  borderColor: semanticColors.primary1
}), (0, _defineProperty3.default)(_inputStates, ':disabled', {
  background: grays.primary6,
  borderColor: grays.primary5,
  cursor: 'not-allowed'
}), (0, _defineProperty3.default)(_inputStates, '::placeholder', {
  color: grays.primary5
}), (0, _defineProperty3.default)(_inputStates, 'error', {
  background: (0, _polished.transparentize)(.9, palette.primary2),
  borderColor: palette.secondary5,
  color: palette.secondary5,
  outline: 0,
  ':focus, :hover': {
    borderColor: semanticColors.primary2,
    background: (0, _polished.transparentize)(.9, palette.primary2)
  },
  ':hover': {
    ':focus': {
      background: (0, _polished.transparentize)(.9, semanticColors.functional2)
    }
  }
}), (0, _defineProperty3.default)(_inputStates, 'required', {}), (0, _defineProperty3.default)(_inputStates, 'focus', {
  borderColor: semanticColors.primary1
}), (0, _defineProperty3.default)(_inputStates, 'success', {
  outline: 0,
  background: (0, _polished.transparentize)(.9, semanticColors.functional1),
  borderColor: palette.functional1,
  color: palette.functional1,
  ':focus, :hover': {
    borderColor: (0, _polished.transparentize)(.5, semanticColors.functional1),
    background: (0, _polished.transparentize)(.9, semanticColors.functional1)
  },
  ':hover': {
    ':focus': {
      background: (0, _polished.transparentize)(.9, semanticColors.functional1)
    }
  }
}), _inputStates);

/*
* special case, because the new theme has so many inputs
*/
var inputVariants = {
  default: (0, _extends4.default)({
    border: '1px solid ' + grays.primary5,
    borderRadius: radii.roundCorner1x,
    padding: space.medium,
    transition: 'height .25s ease-out'
  }, inputStates),
  variant1: (0, _extends4.default)({}, inputStates, {
    background: grays.secondary1,
    border: 0,
    borderRadius: radii.roundCorner1x + 'px ' + radii.roundCorner1x + 'px 0 0',
    padding: space.medium + 2 + 'px ' + space.medium + 'px ' + (space.medium - 2) + 'px',
    borderBottom: '2px solid transparent'
  }),
  variant2: (0, _extends4.default)({}, inputStates, {
    border: 0,
    borderBottom: '1px dashed ' + palette.textPrimary,
    padding: space.xsmall + 'px ' + space.none + 'px',
    ':disabled': (0, _extends4.default)({}, inputStates[':disabled'], {
      background: 'inherit',
      ':focus, :hover': {
        fontWeight: weights.regular,
        borderColor: grays.primary5
      }
    }),
    error: (0, _extends4.default)({}, inputStates.error, {
      background: 'inherit',
      ':focus, :hover': {
        background: 'inherit',
        borderBottom: '1px solid'
      },
      ':hover': {
        ':focus': {
          background: 'inherit'
        }
      }
    }),
    ':focus, :hover': (0, _defineProperty3.default)({
      background: 'inherit',
      borderBottom: '1px solid ' + palette.primary1
    }, '::placeholder', {
      fontWeight: weights.regular
    }),
    required: {},
    success: (0, _extends4.default)({}, inputStates.success, {
      background: 'inherit',
      ':focus, :hover': {
        background: 'inherit',
        borderBottom: '1px solid'
      },
      ':hover': {
        ':focus': {
          background: 'inherit'
        }
      }
    })
  })
};

// const needs to be created just like this. The validate theme javascript
//  requires these format.
var components = {
  alert: {
    padding: space.medium,
    success: {
      border: '1px solid ' + palette.success,
      backgroundColor: '' + (0, _polished.transparentize)(0.9, palette.success),
      color: palette.success,
      iconColor: 'success'
    },
    error: {
      border: '1px solid ' + palette.error,
      backgroundColor: '' + (0, _polished.transparentize)(0.9, palette.error),
      color: palette.error,
      iconColor: 'error'
    },
    info: {
      border: '1px solid ' + palette.info,
      backgroundColor: '' + (0, _polished.transparentize)(0.9, palette.info),
      color: palette.info,
      iconColor: 'info'
    },
    warning: {
      border: '1px solid ' + palette.light,
      backgroundColor: palette.warning,
      color: palette.light,
      iconColor: 'light'
    }
  },
  ariaClickHandler: (0, _extends4.default)({}, focusStyles.minimal),
  badge: {
    backgroundColor: palette.error,
    color: palette.light,
    defaults: function defaults(_ref) {
      var fontColor = _ref.fontColor;

      return {
        textAlign: 'center',
        borderRadius: '1.2em',
        color: fontColor,
        verticalAlign: 'middle',
        display: 'inline-block',
        fontFamily: font.body
      };
    },
    dot: function dot(_ref2) {
      var bgColor = _ref2.bgColor;

      return {
        background: bgColor,
        minWidth: '5px',
        minHeight: '5px',
        height: '5px',
        width: '5px',
        padding: '0px'
      };
    },
    iconPlacement: function iconPlacement(_ref3) {
      var iconMargin = _ref3.iconMargin;

      var marginLeft = iconMargin === 'left' ? '.25em' : 0;
      var marginRight = iconMargin === 'right' ? '.25em' : 0;
      return {
        marginLeft: marginLeft,
        marginRight: marginRight
      };
    },
    notification: function notification(_ref4) {
      var bgColor = _ref4.bgColor;

      return {
        background: bgColor,
        lineHeight: '1.1',
        padding: '2px',
        fontWeight: weights.bold,
        fontStyle: 'normal',
        fontSize: '10px',
        minWidth: '15px',
        height: '15px',
        boxSizing: 'border-box'
      };
    },
    indicatorPosition: {
      absolute: function absolute() {
        return {
          position: 'absolute',
          top: '-5px',
          right: '-5px'
        };
      },
      relative: function relative() {
        return {
          position: 'relative',
          top: 0,
          left: 0
        };
      }
    }
  },
  button: {
    defaults: function defaults(_ref5) {
      var _ref6;

      var primary = _ref5.primary,
          secondary = _ref5.secondary;

      primary = palette[primary];
      secondary = palette[secondary];
      return _ref6 = {
        appearance: 'none',
        background: primary,
        borderColor: colors.transparent,
        borderRadius: radii.round,
        borderStyle: 'solid',
        borderWidth: 1,
        color: secondary,
        cursor: 'pointer',
        fontFamily: font.monospace,
        fontSize: fontSizes.xsmall,
        fontWeight: weights.bold,
        lineHeight: 1,
        textAlign: 'center',
        transition: 'background 0.25s ease-out, color 0.25s ease-out',
        whiteSpace: 'nowrap'
      }, (0, _defineProperty3.default)(_ref6, '&:hover, &:focus', {
        outline: 'none',
        background: (0, _polished.lighten)(.1, primary)
      }), (0, _defineProperty3.default)(_ref6, '&:visited', {
        color: secondary
      }), (0, _defineProperty3.default)(_ref6, '&:active', {
        background: (0, _polished.darken)(.1, primary),
        color: secondary
      }), _ref6;
    },
    inverse: function inverse(_ref7) {
      var _ref8;

      var secondary = _ref7.secondary;
      return _ref8 = {
        borderColor: palette[secondary]
      }, (0, _defineProperty3.default)(_ref8, '&:hover, &:focus', {
        outline: 0,
        color: (0, _polished.lighten)(.1, palette[secondary]),
        borderColor: (0, _polished.lighten)(.1, palette[secondary])
      }), (0, _defineProperty3.default)(_ref8, '&:active', {
        color: (0, _polished.darken)(.1, palette[secondary])
      }), _ref8;
    },
    ghost: function ghost(_ref9) {
      var _ref10;

      var primary = _ref9.primary,
          secondary = _ref9.secondary;
      return _ref10 = {
        background: colors.transparent,
        borderColor: palette[primary],
        color: palette[primary]
      }, (0, _defineProperty3.default)(_ref10, ':hover, :focus', {
        outline: 0,
        color: palette[secondary],
        background: palette[primary],
        fill: palette[secondary],
        svg: {
          fill: palette[secondary]
        }
      }), (0, _defineProperty3.default)(_ref10, ':active', {
        color: palette[secondary]
      }), (0, _defineProperty3.default)(_ref10, ':disabled, :disabled:hover', {
        opacity: 1,
        background: palette.transparent,
        borderColor: palette.disabled,
        color: palette.disabled,
        fill: palette.disabled
      }), (0, _defineProperty3.default)(_ref10, ':disabled svg', {
        fill: palette.disabled
      }), (0, _defineProperty3.default)(_ref10, 'svg', {
        fill: palette[primary]
      }), _ref10;
    },
    minimal: function minimal(_ref11) {
      var _extends2;

      var secondary = _ref11.secondary;
      return (0, _extends4.default)({
        borderWidth: 0,
        background: colors.transparent,
        color: palette[secondary]
      }, focusStyles.minimal.enabled, (_extends2 = {}, (0, _defineProperty3.default)(_extends2, '&:hover, &:focus', {
        background: null,
        outline: 0,
        color: (0, _polished.lighten)(.1, palette[secondary])
      }), (0, _defineProperty3.default)(_extends2, '&:active', {
        background: null,
        color: (0, _polished.darken)(.1, palette[secondary])
      }), _extends2));
    },
    disabled: function disabled(_ref12) {
      var _ref13;

      var primary = _ref12.primary,
          secondary = _ref12.secondary,
          inverse = _ref12.inverse;

      return _ref13 = {
        background: palette[primary],
        borderColor: inverse ? palette[secondary] : colors.transparent,
        color: palette[secondary],
        opacity: 0.3,
        boxShadow: 'none',
        cursor: 'not-allowed'
      }, (0, _defineProperty3.default)(_ref13, '&:hover', {
        background: null
      }), (0, _defineProperty3.default)(_ref13, '&:active', {
        background: null
      }), _ref13;
    },
    sizes: {
      small: {
        height: 24,
        fontSize: fontSizes.xxsmall,
        paddingRight: space.small,
        paddingLeft: space.small
      },
      medium: {
        height: 32,
        fontSize: fontSizes.xsmall,
        paddingRight: space.medium,
        paddingLeft: space.medium
      },
      large: {
        height: 40,
        fontSize: fontSizes.small,
        paddingRight: space.medium,
        paddingLeft: space.medium
      },
      xlarge: {
        height: 56,
        fontSize: fontSizes.medium,
        paddingRight: space.large,
        paddingLeft: space.large
      }
    },
    circle: {
      xsmall: 32,
      small: 40,
      medium: 48,
      large: 56,

      minimal: (0, _extends4.default)({}, focusStyles.minimal)
    }
  },
  checkbox: {
    icon: 'check',
    width: 24,
    height: 24,
    borderRadius: radii.roundCorner1x + 'px',
    rowSpace: space.xsmall,
    label: {
      space: space.small
    },
    checked: {
      border: '1px solid ' + palette.primary1,
      color: 'light',
      backgroundColor: palette.primary1
    },
    unchecked: {
      border: '1px solid ' + palette.primary1,
      backgroundColor: palette.light
    },
    focused: {
      border: '1px solid ' + palette.primary1,
      boxShadow: '0 0 0px 4px ' + (0, _polished.transparentize)(.7, palette.primary1)
    },
    hover: {
      color: palette.primary1,
      border: '1px solid ' + palette.primary1,
      boxShadow: '0 0 0px 4px ' + palette.focusPrimary
    },
    disabled: {
      opacity: 0.3
    }
  },
  floatingPlaceholder: {
    default: {
      color: palette.textTertiary,
      hoverColor: palette.primary1,
      focusColor: palette.primary1
    },
    error: {
      color: palette.secondary5,
      hoverColor: palette.primary2,
      focusColor: palette.primary2
    },
    success: {
      color: palette.functional1,
      hoverColor: palette.functional1,
      focusColor: palette.functional1
    }
  },
  icon: {
    prefix: 'match-',
    size: iconSizes,
    url: function url() {
      return require('./static/theme-icons.svg');
    } // Requires webpack file loader
  },
  image: {
    color: {
      background: palette.stroke
    },
    shape: {
      square: {
        borderRadius: 0
      },
      roundCorner1x: {
        borderRadius: radii.roundCorner1x + 'px'
      },
      roundCorner2x: {
        borderRadius: radii.roundCorner2x + 'px'
      },
      round: {
        borderRadius: '100%'
      }
    },
    defaultImage: function defaultImage() {
      return require('./static/theme-silhouette.svg');
    }
  },
  input: (0, _extends4.default)({}, inputVariants),
  loading: {
    colorName: 'primary1',
    defaultIcon: '',
    sizes: {
      xxsmall: {
        width: 32,
        stroke: 1
      },
      xsmall: {
        width: 48,
        stroke: 2
      },
      small: {
        width: 64,
        stroke: 2
      },
      medium: {
        width: 80,
        stroke: 3
      },
      large: {
        width: 96,
        stroke: 4
      }
    },
    colors: {
      color1: palette.primary1,
      color2: palette.primary2,
      color3: palette.primary1,
      color4: palette.primary2
    },
    mask: {
      backgroundColor: palette.disabled,
      opacity: 0.5
    }
  },
  logo: {
    url: function url() {
      return require('./static/theme-logo.svg');
    }
  },
  modal: {
    config: {
      standardMargin: space.none,
      scrollingModalMargin: space.xxlarge,
      zIndex: zIndex.modal,
      paddingY: space.xxlarge,
      paddingX: '2%',
      borderRadius: radii.roundCorner1x
    },
    ui: (_ui = {
      backgroundColor: palette.light,
      border: 0,
      borderRadius: radii.roundCorner1x,
      boxShadow: dropShadows.z3
    }, (0, _defineProperty3.default)(_ui, ':focus', {
      outline: 'none'
    }), (0, _defineProperty3.default)(_ui, '::-moz-focus-inner', {
      border: 0
    }), _ui),
    closeButton: {
      alignItems: 'center',
      borderRadius: radii.round,
      display: 'flex',
      height: iconSizes.small,
      justifyContent: 'center',
      width: iconSizes.small,
      marginLeft: space.small
    }
  },
  radio: {
    width: 24,
    height: 24,
    borderRadius: radii.round + 'px',
    rowSpace: space.xsmall,
    label: {
      space: space.small
    },
    checked: {
      border: '1px solid ' + palette.primary1,
      backgroundColor: palette.light
    },
    checkedDot: {
      width: 12,
      height: 12,
      border: '1px solid ' + palette.light,
      backgroundColor: palette.primary1
    },
    unchecked: {
      border: '1px solid ' + palette.primary1,
      backgroundColor: palette.light
    },
    focused: {
      boxShadow: '0 0 0px 4px ' + (0, _polished.transparentize)(.7, palette.primary1)
    },
    hover: {
      color: palette.primary1,
      boxShadow: '0 0 0px 4px ' + palette.focusPrimary
    },
    disabled: {
      opacity: 0.5
    }
  },
  select: {
    borderColor: palette.stroke,
    focus: {
      backgroundColor: palette.focusPrimary
    },
    selected: {
      color: palette.primary1
      // backgroundColor: palette.focusPrimary,
    },
    dropdown: {
      borderRadius: radii.roundCorner1x + 'px',
      backgroundColor: palette.light,
      boxShadow: '0 10px 30px 8px ' + palette.stroke,
      maxWidth: 300,
      minWidth: 150
    },
    error: {
      borderColor: palette.error
    },
    hasSelection: {
      borderColor: palette.primary1
    },
    color: palette.textPrimary
  },
  slider: {
    size: 24,
    track: {
      size: 4,
      offset: 12,
      backgroundColor: palette.primary1,
      borderRadius: radii.roundCorner1x + 'px',
      disabled: {
        backgroundColor: palette.disabled
      }
    },
    rail: {
      size: 4,
      backgroundColor: palette.stroke,
      borderRadius: radii.roundCorner1x + 'px',
      disabled: {
        backgroundColor: palette.stroke
      }
    },
    handle: {
      border: 'none',
      borderRadius: radii.round + 'px',
      width: 24,
      height: 24,
      leftOffset: -12,
      topOffset: -10,
      backgroundColor: palette.light,
      boxShadow: '0 2px 8px 0 ' + (0, _polished.transparentize)(0.8, palette.dark),
      focus: {
        border: '0px solid ' + (0, _polished.darken)(0.7, palette.dark),
        boxShadow: '0 0 8px 2px ' + (0, _polished.transparentize)(0.7, palette.primary1)
      },
      hover: {
        border: '0px solid ' + (0, _polished.lighten)(0.7, palette.dark),
        boxShadow: '0 0 8px 2px ' + (0, _polished.transparentize)(0.7, palette.primary1)
      },
      active: {
        border: '0px solid ' + (0, _polished.darken)(0.7, palette.dark),
        boxShadow: '0 0 8px 2px ' + (0, _polished.transparentize)(0.7, palette.primary1)
      },
      disabled: {
        backgroundColor: palette.stroke,
        boxShadow: 'none',
        borderColor: palette.stroke
      }
    },
    mark: {
      color: palette.textTertiary,
      offset: 32,
      active: {
        color: palette.primary1
      }
    },
    step: {
      size: 4,
      offset: 12,
      backgroundColor: 'none'
    },
    dot: {
      width: 8,
      height: 8,
      yOffset: -2,
      xOffset: -4,
      border: '2px solid ' + palette.stroke,
      backgroundColor: palette.stroke,
      borderRadius: radii.round + 'px',
      active: {
        borderColor: palette.primary1,
        backgroundColor: palette.primary1
      },
      disabled: {
        backgroundColor: palette.disabled,
        boxShadow: 'none',
        borderColor: palette.stroke
      }
    }
  },
  switch: {
    width: 56,
    height: 32,
    borderRadius: radii.round + 'px',
    on: {
      backgroundColor: palette.primary1,
      border: '1px solid ' + palette.primary1
    },
    off: {
      backgroundColor: palette.stroke,
      border: '1px solid ' + palette.stroke
    },
    slider: {
      width: 32,
      height: 32,
      borderRadius: radii.round + 'px',
      boxShadow: '-1px 1px 2px ' + (0, _polished.transparentize)(.7, palette.dark),
      backgroundColor: palette.light
    },
    focused: {
      boxShadow: '0px 0px 8px 2px ' + (0, _polished.transparentize)(.7, palette.primary1),
      border: '1px solid transparent'
    },
    disabled: {
      opacity: 0.3
    }
  },
  overlay: {
    color: {
      dark: palette.dark,
      light: palette.light
    },
    zIndex: zIndex.overlay
  },
  textArea: {
    default: (0, _extends4.default)({
      transition: 'height .25s ease-out',
      padding: space.medium
    }, inputVariants.default),
    noResize: {
      resize: 'none'
    },
    singleLine: {
      paddingBottom: 0
    },
    variant1: inputVariants.variant1
  }
};

// theme needs to be created just like this. The validate theme javascript
//  requires these format. It is exported down below
var theme = {
  branding: branding,
  components: components,
  dropShadows: dropShadows,
  font: font,
  fontSizes: fontSizes,
  fontVariants: fontVariants,
  iconSizes: iconSizes,
  palette: palette,
  radii: radii,
  space: space,
  typography: typography,
  weights: weights,
  lineHeights: lineHeights,
  zIndex: zIndex
};

exports.default = theme;